var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 200,
    viewBox: "0 0 251 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.5 65a7 7 0 110 14h-40a7 7 0 110 14h22a7 7 0 110 14h-10.174c-4.874 0-8.826 3.134-8.826 7 0 2.577 2 4.911 6 7a7 7 0 110 14h-83a7 7 0 110-14h-39a7 7 0 110-14h40a7 7 0 100-14h-25a7 7 0 110-14h40a7 7 0 110-14h98zm0 28a7 7 0 110 14 7 7 0 010-14z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.453 70.518l83.024-13.292a3 3 0 013.437 2.488l.001.01 8.122 51.832a3 3 0 01-2.489 3.427l-83.025 13.291a3 3 0 01-3.437-2.488l-.001-.01-8.122-51.832a3 3 0 012.49-3.426z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.023 69.576l.477 3.133m-74.655 54.714l-3.183.525c-2.187.36-4.24-1.192-4.587-3.467L68.55 75.039c-.346-2.275 1.145-4.412 3.332-4.773l80.176-13.214c2.187-.36 4.24 1.192 4.587 3.468l.807 5.3-73.607 61.603z",
    stroke: "#F79009",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.477 72.792l75.76-11.831a3 3 0 013.425 2.488l7.36 45.819a3 3 0 01-2.486 3.438l-.013.002-75.76 11.831a3 3 0 01-3.425-2.488l-7.36-45.82a3 3 0 012.486-3.437l.013-.002z",
    fill: "#FEF0C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.25 77.25h-78.5a4 4 0 00-4 4v48.5a4 4 0 004 4h78.5a4 4 0 004-4v-48.5a4 4 0 00-4-4z",
    fill: "#fff",
    stroke: "#F79009",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174 89H90v14h84V89z",
    fill: "#FEF0C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.789 89h-7.196m78.078 0h-65.84 65.84zm-6 13h-78.84 78.84zm-43.109 19H97.255h28.307z",
    stroke: "#F79009",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgOrange;